import { render, staticRenderFns } from "./list-3.vue?vue&type=template&id=93479984&scoped=true"
import script from "./list-3.vue?vue&type=script&lang=js"
export * from "./list-3.vue?vue&type=script&lang=js"
import style0 from "./list-3.vue?vue&type=style&index=0&id=93479984&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93479984",
  null
  
)

export default component.exports